module.exports = __webpack_public_path__ + "img/theme.fe97a490.png";